import React, { useCallback } from "react";
import { fetchResetUserPassword } from "../../services/useAuth";
import { Auth } from "aws-amplify";
import { useLoginStore } from "../../../state/LoginStore";

export function useSendForgotPassCode(
    setForgotPassword: React.Dispatch<boolean>,
    setLoading: React.Dispatch<boolean>,
    setAuthFlowErrorType: React.Dispatch<string>,
    setAuthFlowError: React.Dispatch<string>) {

    const setSeverity = useLoginStore((state) => state.setSeverity);
    const setOpenAlert = useLoginStore((state) => state.setOpenAlert);


    const sendForgotPassCode = useCallback(async (userName: string) => {
        try {
            setLoading(true);
            const resp = await fetchResetUserPassword(userName);
            const data = await resp.json();

            if (data.wasReset) {
                return { wasPassWordResent: true };
            }

            const res = await Auth.forgotPassword(userName);
            if (res) setForgotPassword(true);
            return {}

        } catch (e: any) {
            setSeverity("error")
            setOpenAlert(true);
            setAuthFlowErrorType(e.code);
            setAuthFlowError(e.message);
            console.log('e.message', e);
        } finally {
            setLoading(false);
        }
    }, [setAuthFlowError, setAuthFlowErrorType, setForgotPassword, setLoading, setOpenAlert, setSeverity])

    return { sendForgotPassCode }
}
